<template>
  <div class="grid grid-cols-2 gap-4 h-full">
    <div class="border-t bg-white overflow-auto py-4 rounded shadow h-full">
      <div class="font-semibold text-l mx-4 mb-4 text-gray-500">Guests Count</div>
      <div class="px-2">
        <canvas id="graph" class=""></canvas>
      </div>
    </div>
    <div class="border-t bg-white overflow-auto py-4 rounded shadow h-full">
      <div class="font-semibold text-l mx-4 mb-4 text-gray-500">Bandwidth Usage</div>
      <div class="px-2">
        <canvas id="bandwidth-graph" class=""></canvas>
      </div>
    </div>
  </div>
</template>

<script>
import GraphQl from "../../services/graphql.service";
import moment from "moment";
import Chart from "chart.js"; 

export default {
  name: "ConnectionsGraph",
  chart: Object,
  bandwidthChart: Object,
  props: {
    filters: Object
  },
  data() {
    return {
      chartData: {
        data: {
          datasets: [
            {
              label: "Footfall",
              type: 'line',
              fill: true,
              backgroundColor:'rgba(252,129,129,0.2)',
              showLines: false,
              borderColor: 'rgba(252,129,129,0.8)',
              lineTension: .5,
              borderWidth: .5,
              data: []
            },
            {
              label: "Connected",
              type: 'bar',
              fill: true,
              backgroundColor: 'rgba(12,148,136,0.5)',
              showLines: false,
              borderColor: 'rgba(12,148,136,1)',
              lineTension: .4,
              borderWidth: 0,
              data: []
            }
          ]
        },
        options: {
          legend: {
            display: false,
            labels: {
              fontColor: 'teal'
            }
          },
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true,
                min: 0
              },
              scaleLabel: {
                display: true,
                labelString: "Connections count"
              }
            }],
            xAxes: [{
              type: "time",
              time: {
                unit: "hour"
              },
              distribution: 'linear'
            }],
          }
        }
      },
      bandwidthChartData: {
        data: {
          datasets: [
            {
              label: "Upload",
              type: 'line',
              fill: true,
              backgroundColor: 'rgba(246,132,0,0.3)',
              showLines: false,
              borderColor: 'rgba(246,132,0,1)',
              lineTension: .5,
              borderWidth: .5,
              data: []
            },
            {
              label: "Download",
              type: 'line',
              fill: true,
              backgroundColor: 'rgba(0,74,134,0.2)',
              showLines: false,
              borderColor: 'rgba(0,74,134,0.8)',
              lineTension: .5,
              borderWidth: 0,
              data: []
            }
          ]
        },
        options: {
          legend: {
            display: false,
            labels: {
              fontColor: 'teal'
            }
          },
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true,
                min: 0
              },
              scaleLabel: {
                display: true,
                labelString: "Usage (GBs)"
              }
            }],
            xAxes: [{
              type: "time",
              time: {
                unit: "hour"
              },
              distribution: 'linear'
            }],
          }
        }
      },
    }
  },
  mounted() {
    this.chart = new Chart(document.getElementById("graph"), {
      type: 'line',
      data: this.chartData.data,
      options: this.chartData.options,
    });
    this.bandwidthChart = new Chart(document.getElementById("bandwidth-graph"), {
      type: 'line',
      data: this.bandwidthChartData.data,
      options: this.bandwidthChartData.options,
    });
    this.loadStats();
  },
  watch: {
    filters: {
      handler: function () {
        this.loadStats();
      },
      deep: true
    }
  },
  methods: {
    loadStats() {

      let v = [];
      this.filters.venues.forEach(function (venue) {
        v.push(venue.id);
      });

      let params = (this.filters.venues.length > 0 ? 'venues:["' + v.join('","') + '"],' : '') +
          'startDate: "' + moment(this.filters.dateRange.startDate).format('YYYY-MM-DD 00:00:00') + '", ' +
          'endDate: "' + moment(this.filters.dateRange.endDate).format('YYYY-MM-DD 23:59:59') + '"';


      this.chartData.data.datasets[0].data = [];
      this.chartData.data.datasets[1].data = [];
      this.bandwidthChartData.data.datasets[0].data = [];
      this.bandwidthChartData.data.datasets[1].data = [];
      GraphQl.sendRequest('{usageSummary(' + params + '){footfall connections upload download created hour date }}')
          .then((response) => {
            response.usageSummary.forEach((stat) => {
              var time = moment(stat.date +" "+ stat.hour +":00:00", 'YYYY-MM-DD HH:mm').valueOf();
              this.chartData.data.datasets[0].data.push({
                t:time,
                y: stat.footfall
              });

              this.chartData.data.datasets[1].data.push({
                t: time,
                y: stat.connections
              });


              this.bandwidthChartData.data.datasets[0].data.push({
                t:time,
                y: (stat.upload / (1024 * 1024 * 1024)).toFixed(2)
              });

              this.bandwidthChartData.data.datasets[1].data.push({
                t: time,
                y: (stat.download / (1024 * 1024 * 1024)).toFixed(2)
              });
            });

            this.chart.update();
            this.bandwidthChart.update();

          })
    }
  }
}
</script>

<style scoped>

</style>